module.exports = __webpack_public_path__ + "static/media/36.37f38d7d.svg";